export const LIFECYCLE_TABLE_SORT_KEY = "lifecycleTableSort";

export const LIFECYCLE_SORT_FIELDS = ["title", "description", "createdDate", "modifiedDate"] as const;

export type LifecycleSortField = (typeof LIFECYCLE_SORT_FIELDS)[number];

/** API lifecycle row shape used for sorting (CreatedDate from OData). */
export type LifecycleRow = {
  Title?: string;
  Description?: string;
  CreatedDate?: string;
  ModifiedDate?: string;
};

export function compareLifecycleRows(
  a: LifecycleRow,
  b: LifecycleRow,
  field: LifecycleSortField
): number {
  if (field === "title") {
    return (a.Title || "").localeCompare(b.Title || "", undefined, { sensitivity: "base" });
  }
  if (field === "description") {
    return (a.Description || "").localeCompare(b.Description || "", undefined, {
      sensitivity: "base",
    });
  }
  if (field === "modifiedDate") {
    const ta = new Date(a.ModifiedDate || 0).getTime();
    const tb = new Date(b.ModifiedDate || 0).getTime();
    return ta - tb;
  }
  const ta = new Date(a.CreatedDate || 0).getTime();
  const tb = new Date(b.CreatedDate || 0).getTime();
  return ta - tb;
}
